require.context('./', true, /\.(ttf|eot|svg|png|jpe?g|gif|ico|woff)(\?.*)?$/i);
